<!--
 * @Author: 张天昊
 * @Date: 2024-05-25 16:58:52
 * @LastEditTime: 2024-06-04 14:31:45
 * @LastEditors: 张天昊
 * @Description: 手机号container
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/WithPhone.vue
-->
<script>
import { defineComponent, computed } from 'vue';
import { isEncryptStr, genEmptyTextPlaceholder } from '../utils';

export default defineComponent({
  props: {
    phoneNumber: {
      type: String
    }
  },
  setup(props) {
    const href = computed(() => {
      if (!props.phoneNumber) {
        return void 0
      }
      return isEncryptStr(props.phoneNumber)
        ? void 0
        : `tel:${props.phoneNumber}`;
    });
    return {
      href,
      genEmptyTextPlaceholder
    };
  }
});
</script>

<template>
  <a class="inline-flex items-center van-haptics-feedback" :href="href" @click.stop>
    <slot>
      {{ genEmptyTextPlaceholder(phoneNumber) }}
    </slot>
    <svg-icon
      v-if="href"
      pre-path="itineraryUniversal"
      name="ic-phone"
      class="ml-8 w-22 h-22"
    />
  </a>
</template>
